module.exports = __webpack_public_path__ + "img/icon-excel.74617194.svg";